import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';
import { hasRequiredCampaignParams } from '@/utils/campaignAccess';
import {
  hasPaywallWebViewBridge,
  hasPaywallWebViewUserAgent,
} from '@/utils/webViewAccess';

interface CampaignRouteGuardProps {
  children: ReactNode;
}

export function CampaignRouteGuard({ children }: CampaignRouteGuardProps) {
  const location = useLocation();

  const hasWebViewUserAgent = hasPaywallWebViewUserAgent();
  if (hasWebViewUserAgent) {
    return <>{children}</>;
  }

  if (hasPaywallWebViewBridge() || !hasRequiredCampaignParams(location.search)) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <>{children}</>;
}
